import { render, staticRenderFns } from "./ListValidationHistory.vue?vue&type=template&id=23bb2c90"
import script from "./ListValidationHistory.vue?vue&type=script&lang=js"
export * from "./ListValidationHistory.vue?vue&type=script&lang=js"
import style0 from "./ListValidationHistory.vue?vue&type=style&index=0&id=23bb2c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIntersection,QCard,QIcon,QTooltip,QBtn,QList,QItem,QItemSection,QInput});
